import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['template']
  static values = {
    filename: { type: String, default: 'Vesselindex' },
    sheetSize: { type: String, default: 'A4' },
    orientation: { type: String, default: 'landscape' },
    margin: { type: String, default: '8mm 10mm' }
  }

  connect() {
    this.element.addEventListener('print-template', this.printTemplate.bind(this))
  }

  printTemplate(event) {
    const pages = event.detail.pages
    const printHtml = this.#getPrintHtml(pages)
    const iframe = this.#renderIframe(printHtml)

    setTimeout(() => {
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
      document.body.removeChild(iframe)
    }, 500) // Small delay to ensure CSS rendering
  }

  #getPrintHtml(pages) {
    const printTemplate = Array.from(this.element.content.children)
    const headTemplate = printTemplate.find(t => t.dataset.role === 'head').content
    const headerTemplate = printTemplate.find(t => t.dataset.role === 'header').content.firstElementChild
    const contentTemplate = printTemplate.find(t => t.dataset.role === 'content').content.firstElementChild
    const footerTemplate = printTemplate.find(t => t.dataset.role === 'footer').content.firstElementChild

    let bodyHtml = ''
    if (pages && pages.length > 0) {
      pages.forEach(page => {
        const pageClone = contentTemplate.cloneNode(true)
        const headerClone = headerTemplate.cloneNode(true)
        const footerClone = footerTemplate.cloneNode(true)
        pageClone.innerHTML = page.content
        headerClone.querySelector('.js-print-page-title').textContent = page.title || 'VESSELINDEX® Report'
        footerClone.querySelector('.js-print-page-number').textContent = pages.indexOf(page) + 1
        footerClone.querySelector('.js-print-total-pages').textContent = pages.length
        bodyHtml += this.#buildPage(headerClone, pageClone, footerClone)
      })
    } else {
      bodyHtml = this.#buildPage(headerTemplate, contentTemplate, footerTemplate)
    }

    const cssCustomProperties = /* css */`
      body.c-print {
        --print-page-margin: ${this.marginValue};
        --print-sheet-size: ${this.sheetSizeValue.toUpperCase()};
        --print-orientation: ${this.orientationValue.toLowerCase()};
      }
      @page {
        size: ${this.sheetSizeValue.toUpperCase()} ${this.orientationValue.toLowerCase()};
        margin: ${this.marginValue};
      }
    `

    const printHtml = /* html */`
      <html>
        <head>
          ${Array.from(headTemplate.children).map(child => child.outerHTML).join('')}
          <style>
            ${cssCustomProperties}
          </style>
        </head>
        <body class="c-print">
          ${bodyHtml}
        </body>
      </html>
    `

    return printHtml
  }

  #buildPage(header, content, footer) {
    return /* html */`
      <div class="c-print_page">
        ${header.outerHTML}
        ${content.outerHTML}
        ${footer.outerHTML}
      </div>
    `
  }

  #renderIframe(printHtml) {

    if (!printHtml) return

    const iframe = document.createElement('iframe')
    iframe.classList.add('c-print-iframe')
    document.body.appendChild(iframe)

    const doc = iframe.contentWindow.document
    doc.open()
    doc.write(printHtml)
    doc.close()

    return iframe
  }
}
